import React from 'react';
import {StyledSocial, SocialLinks, SocialList} from '../styles';

const Socials =()=>{
return(
    <>
    <StyledSocial>
    <SocialList>
        <SocialLinks
          href="https://www.linkedin.com/in/jasmineterry92"> LinkedIn </SocialLinks>
      
        <SocialLinks href="https://Github.com/jTCode2408"> Github
        </SocialLinks>
      
        <SocialLinks href="mailto: &#106;&#97;&#115;&#109;&#105;&#110;&#101;&#46;&#116;&#101;&#114;&#114;&#121;&#57;&#49;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"> Email </SocialLinks>

    </SocialList>
  </StyledSocial> {/*socials div end */}
</>

)


}

export default Socials